import styled from "@emotion/styled";

export const Container = styled.section`
  width: 100%;
  text-align: center;
`;

export const IconsList = styled.ul`
  list-style: none;
  width: 100%;
  max-height: 50vh;

  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto;

  padding: 0;
  margin-top: 1rem;
`;
